import { USMapWrapper } from './wrapper';
import { USMapKnobs } from './knobs';
import { facets } from 'widgets/endpoints';
import { PropertyFlag as SrsPropertyFlag } from 'srs-middleware';
import {filterProperties} from "utilities/srsUtils";

const flags = [SrsPropertyFlag.Categorical];

export const config = {
  key: "US_MAP",
  label: 'US Map',
  icon: 'globe',
  wrapper: USMapWrapper,
  endpoint: facets,
  Knobs: USMapKnobs,
  flags: flags,
  createDefaultOptions: (filteredProperties) => {
    return {
      options: {
        propertyList: [
          filteredProperties[0].name,
        ],
        parameters: {},
      },
    };
  },
  createDefaultConfiguration: (_filteredProperties) => {
    return {
      showLegend: true,
    };
  },
  isValid: (selectedDefinitionName) => {
    return filterProperties(selectedDefinitionName, flags).length >= 1;
  },
};
